import { Component, Input } from '@angular/core';

@Component({
    selector: 'bws-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.css'],
    standalone: false
})
export class BreadcrumbComponent {

  @Input() items: BwsBreadCrumb[] = [];
  @Input() title: string = '';
  @Input() navigateBackLink: string = '';

}

export interface BwsBreadCrumb {
  title: string;
  routerLink?: string;
}
